// extracted by mini-css-extract-plugin
export default {"dark":"SinglePortfolioPage_dark__NRpRW","root":"SinglePortfolioPage_root__3AFyR","page":"SinglePortfolioPage_page__whacU"};